import { render, staticRenderFns } from "./MySubmissionsTable.vue?vue&type=template&id=5b6d8293&scoped=true"
import script from "./MySubmissionsTable.vue?vue&type=script&lang=js"
export * from "./MySubmissionsTable.vue?vue&type=script&lang=js"
import style0 from "./MySubmissionsTable.vue?vue&type=style&index=0&id=5b6d8293&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6d8293",
  null
  
)

export default component.exports